module.exports = __webpack_public_path__ + "static/media/detail.1984929f.png";